import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var buildTableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
        MD5: string;
        SHA1: string;
        SHA256: string;
    }
}

export class DetailPage extends PageBase<IndexPageOptions> {
    protected  _tableOptions: DatatableOptions;
    protected  _table: Datatable;
    protected  _tableId: string;

    constructor(options: IndexPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this._tableId = "tableCustomerOperations";
        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            autoFocusSearch: false,
            columns: [
                {
                    data: "CustomerName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCustomerName${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'CustomerOperationName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnName${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'ModuleVersion',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnBuildVersion${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Currencies',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCurrencies${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    data: "ModuleDescription",
                    render: (data: any, type: any, rowData: any) => 
                        (`<span id='spnDescription${rowData.Id}'>${data}</span>`)
                }
            ]
        };

        
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(this._tableId, this._tableOptions);
    }
}

export class BuildInformation extends PageBase<IndexPageOptions> {
    protected _tableOptions: DatatableOptions;
    protected _table: Datatable;
    protected _tableId: string;

    constructor(options: IndexPageOptions) {
        super(options);
        this.removeSelected = this.removeSelected.bind(this);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.GameId}/${rowData.Version}`);

        this._tableId = "tableBuildInformation";
        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: buildTableDom,
            rowId: 'Version',
            autoWidth: true,
            autoFocusSearch: false,
            ordering: false,
            columns: [
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<input type='checkbox' name='selectedBuild' id='chckVersion${rowData.Version}' value='${rowData.Version}' />`)
                },
                {
                    sortable: false,
                    data: "Version",
                    //render: (data: any, type: any, rowData: any) =>
                    //    (`<a id='lnkVersion${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</span>`)
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkVersion${rowData.Version}' href='${getDetailUrl(rowData)}'>${data}</span>`)
                },
                {
                    data: 'Hashes',
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (data.hasOwnProperty("MD5")) {
                            md5 = data['MD5'];
                        }
                        if (data.hasOwnProperty("SHA1")) {
                            sha1 = data['SHA1'];
                        }
                        if (data.hasOwnProperty("SHA256")) {
                            sha256 = data['SHA256'];
                        }
                        return `<table id='tblStringContent${rowData.StringVersion}' class='buildVersion-table'>
                                <tr><td>${options.localizer.MD5}: </td><td>${md5}</td></tr>
                                <tr><td>${options.localizer.SHA1}: </td><td>${sha1}</td></tr>
                                <tr><td>${options.localizer.SHA256}: </td><td>${sha256}</td></tr>
                          </table>`;
                    }
                },
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Version}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'BuiltOn',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Version}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: 'Description',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDescription${rowData.Version}'>${data}</span>`)
                },
                {
                    sortable: false,
                    data: "IsEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "IsValid",
                    render: (data: any, type: any, rowData: any) => {
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${StringUtils.capitalizeFirstLetter(data.toString())}</span>`;
                    }
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(this._tableId, this._tableOptions);
        let btnRemove = Utils.getJQueryById("btnRemoveSelected");
        btnRemove.on("click", this.removeSelected);
    }

    private removeSelected(e: JQueryEventObject): void {
        e.preventDefault();
        if (!confirm("Are you sure you want to remove selected builds?")) {
            return;
        }
        let urlPost = this._options.urlPost;
        var versions = $("input[name='selectedBuild']:checked").map(function () {
            return $(this).val();
        });
        let versionsToRemove = versions.get();
        if (!versionsToRemove || versionsToRemove.length === 0) {
            return;
        }
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'json',
            data: { versions: versionsToRemove },
            success: function (data) {
                window.location.href = data;
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Games/DetailPage.ts
 **/